<template>
     <main class="pd-main">
        <div class="main-content">
            <header class="header no-border">
                <div class="header-bar">
                    <h4 class="text-uppercase">Certifications</h4>
                </div>
            </header>
            <circle-spin class=" m-0" v-if="firstLoad"></circle-spin>
            <div v-else>
                <div class="row mb-20 no-margin card card-body">
                    <!-- <h5>Download certifications for passed trainings!</h5> -->
                    <h5>View and Download certificates for passed trainings</h5>
                    <p>We’re still working on download of certifications on each training. The feature will be available soon.<br>
                    </p>
                    <p>Email us at <strong>support@mentalcare.life</strong> if you have any questions.</p>
                </div>
                    <div class="row" v-if="completed_trainings.length > 0">
                        <div class="col-sm-6 col-md-4 col-xl-3" v-for="(training, index) in completed_trainings" :key="index">
                            <div class="card card-body">
                                <div>
                                    <span class="ion-ios-people text-primary fs-60"></span>
                                </div>
                                <h5 class="text-uppercase">{{training.title}}</h5>
                                <p>Test Score: <strong>{{training.listener_training.score}}</strong></p>
                                <!-- <div class="flexbox justify-content-start">
                                    <a href="#" class="btn btn-sm bg-1 text-uppercase">Download</a>
                                </div> -->
                            </div>
                            
                        </div>
                    </div>
                    <div v-else class="card card-body p-50 text-center">
                        <div class="pb-10">
                            <i class="fs-svg ion-ios-list"></i>
                        </div>
                        <div class="mb-10">
                            <h5> You have no completed trainings.</h5>
                            You have to take and pass a training to be able to download a certification.<br>
                            <router-link to="/listener/trainings" tag="a" class="mt-10 btn btn-sm btn-round btn-primary">Take Training</router-link>
                        </div>
                    </div>
            </div>
        </div>
    </main>
</template>

<script>
import axios from 'axios'
import allMixins from '../../mixins.js'
import noTraining from '../../components/user/NoTraining.vue'

export default {
    mixins: [allMixins],
    data() {
        return {
            firstLoad: true,
            loading: false,
            completed_trainings: [],
        }
    },
    mounted() {
        let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")

        axios.get(`users/find/${details.id}`)
        .then(res => {
            this.firstLoad = false
            this.completed_trainings = res.data.listener[0].trainings
        })
        .catch(err => {
            this.firstLoad = false
        })
    },
    components: {
        noTraining
    }
}
</script>